import { Component, OnInit, ContentChild, TemplateRef, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';
import * as _ from 'lodash';

@Component({
  selector: 'mapfre-auditlib-select-group',
  templateUrl: './select-group.component.html',
  styleUrls: ['./select-group.component.scss']
})
export class SelectGroupComponent implements OnInit {


  @ContentChild('selectedItemsTemplate', { static: false }) selectedItemsTemplate: TemplateRef<any>;
  @ContentChild('itemTemplate', { static: false }) itemTemplate: TemplateRef<any>;

  @Input() field;
  @Input() label;
  @Input() icon;
  @Input() placeholder;
  @Input() form;
  @Input() selectionMode;
  @Input() data;
  @Input() readonly;
  @ViewChild('simple', { static: false }) simple: MultiSelect;
  private model;

  @Output()
  onChange = new EventEmitter();


  constructor() { }

  ngOnInit() {
    this.selectionMode = this.selectionMode || 'multiple';
    if (this.selectionMode === 'simple') {
      this.onModelChange(this.form.value, false);
    }
    this.form.valueChanges.subscribe((newValue) => {
      this.onModelChange(newValue, true);
    });
  }

  onModelChange(newValue, isSubscribe) {
    // this.model = [_.last(newValue)];
    // this.form.setValue(_.head(this.model));
    //_.attempt(_.get(this.simple, 'hide')); 
    if (newValue !== null) {
      this.model = _.isArray(newValue) ? [_.last(newValue)] : [newValue];
      if (!isSubscribe) {
        this.form.setValue(_.head(this.model));
      }
    } else {
      this.model = null;
      if (!isSubscribe) {
        this.form.setValue(null)
      }
    }
    if (this.simple) {
      setTimeout(() => this.simple.hide()
      )
    };
  }

  onChangeHandler(event) {
    this.onChange.emit(event);
  }

}
